import { useEffect, useState } from "react";
import useWindowWidth from "./useWindowWidth";

const useMenuToggle = () => {
  const [toggleMenu, setToggleMenu] = useState(false);
  const width = useWindowWidth();

  useEffect(() => {
    if (width) {
      if (width <= 576) {
        setToggleMenu(false);
      } else if (width <= 1400) {
        //was 1280
        setToggleMenu(false);
      } else {
        setToggleMenu(true);
      }
    } else {
      setToggleMenu(true);
    }
  }, [width]);

  return toggleMenu;
};

export default useMenuToggle;
